export class SessionCapacityError extends Error {
    constructor() { super('Session state could not be saved without exceeding the local history capacity.'); this.name = 'SessionCapacityError'; }
}
export function isDirectMessageSessionScope(scope) {
    return scope.guildId === `dm:${scope.accountId}`;
}
export const SESSION_MAX_BYTES = 50 * 1024 * 1024;
export const sessionKey = (scope) => JSON.stringify([scope.accountId, scope.guildId, scope.channelId, scope.agentId, ...(scope.bindingId ? [scope.bindingId] : [])]);
export const sessionRecordBytes = (record) => new TextEncoder().encode(JSON.stringify(record)).byteLength;
export const sessionTurnKey = (record) => JSON.stringify([record.generation, record.frame.task_id]);
//# sourceMappingURL=journal.js.map